module.exports = __webpack_public_path__ + "assets/img/tescol.f3be5a63.png";